import { createFileRoute } from '@tanstack/react-router';
import { UltimosAtendimentos } from '@/features/atendimentos/componentes/UltimosAtendimentos';
import { Inicio } from '@/features/inicio/componentes/Inicio';
import { rotaDeTela } from '@/features/permissoes/guardas';
import { UltimosTreinos } from '@/features/registros/componentes/UltimosTreinos';

/** Início (spec 015): os blocos das outras funcionalidades são compostos aqui (ADR-0003). */
export const Route = createFileRoute('/_autenticado/')({
  ...rotaDeTela('inicio'),
  component: Pagina,
});

function Pagina() {
  const { me } = Route.useRouteContext();
  return <Inicio me={me} atendimentos={<UltimosAtendimentos />} treinos={<UltimosTreinos />} />;
}
